import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Icons from '../../assets/images/index';
import { viewOneBuildingType } from '../../services/buildingType';
import _ from 'underscore';
import { useDispatch } from "react-redux";

const BuildingTypeView = () => {
    const dispatch = useDispatch();
    const [buildingTypeData, setBuildingTypeData] = useState()

    let building_type_id = useParams();

    useEffect(() => {
        viewOneBuildingType(building_type_id, (data) => {
            setBuildingTypeData(data)
        })
    }, [dispatch])


    return (
        <div className='dashboard-inner'>
            <div className='d-card m-b-25'>
                <div className='d-card-header'>
                    <h5 className='d-card-heading'>Building Type Management</h5>
                    <div className='d-card-actions'>
                        <label htmlFor='toggleSwitch001' className='toggle-switch m-r-10'>
                            <input type="checkbox" id='toggleSwitch001' />
                            <h6 className='deactivate'>Inactive</h6>
                            <h6 className='activate'>Active</h6>
                            <span className='toggle-bar'></span>
                        </label>
                        <Link className="dashboard-action" to="/" title="Edit">
                            <img src={Icons.edit} alt="" height="20px" />
                        </Link>
                        <button className="dashboard-action" title="Delete">
                            <img src={Icons.bin} alt="" height="20px" />
                        </button>
                    </div>
                </div>
                <div className='d-card-body p-b-0'>
                    <div className="f-row">
                        <div className="f-auto">
                            <div className="desc-info">
                                <h6 className="desc-info-heading">Building-Type Name</h6>
                                <p className="desc-info-detail">{buildingTypeData && buildingTypeData.building_type_name}</p>
                            </div>
                        </div>
                    </div>
                    <div className="desc-info">
                        <p className="desc-info-detail">{buildingTypeData && buildingTypeData.description}</p>
                    </div>
                </div>
            </div>
            <div className='d-card'>
                <div className='d-card-header'>
                    <h5 className='d-card-heading'>Popular Usage</h5>
                </div>
                <div className='d-card-body p-b-0'>
                    <div className='responsive-table'>
                        <table className='table-odd-even'>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className='bid-details'>
                                            <span className='bid-icon'>
                                                <img src={Icons.projectImg} alt='' />
                                            </span>
                                            <h4>Amet minim mollit</h4>
                                        </div>
                                    </td>
                                    <td>
                                        <h5 className='bid-closing'>Date: 14/05/2022</h5>
                                    </td>
                                    <td>
                                        <h5 className='bid-closing'>Price: $5599 USD</h5>
                                    </td>
                                    <td>
                                        <h5 className='bid-closing'>Location: California</h5>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className='bid-details'>
                                            <span className='bid-icon'>
                                                <img src={Icons.projectImg} alt='' />
                                            </span>
                                            <h4>Amet minim mollit</h4>
                                        </div>
                                    </td>
                                    <td>
                                        <h5 className='bid-closing'>Date: 14/05/2022</h5>
                                    </td>
                                    <td>
                                        <h5 className='bid-closing'>Price: $5599 USD</h5>
                                    </td>
                                    <td>
                                        <h5 className='bid-closing'>Location: California</h5>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className='bid-details'>
                                            <span className='bid-icon'>
                                                <img src={Icons.projectImg} alt='' />
                                            </span>
                                            <h4>Amet minim mollit</h4>
                                        </div>
                                    </td>
                                    <td>
                                        <h5 className='bid-closing'>Date: 14/05/2022</h5>
                                    </td>
                                    <td>
                                        <h5 className='bid-closing'>Price: $5599 USD</h5>
                                    </td>
                                    <td>
                                        <h5 className='bid-closing'>Location: California</h5>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className='bid-details'>
                                            <span className='bid-icon'>
                                                <img src={Icons.projectImg} alt='' />
                                            </span>
                                            <h4>Amet minim mollit</h4>
                                        </div>
                                    </td>
                                    <td>
                                        <h5 className='bid-closing'>Date: 14/05/2022</h5>
                                    </td>
                                    <td>
                                        <h5 className='bid-closing'>Price: $5599 USD</h5>
                                    </td>
                                    <td>
                                        <h5 className='bid-closing'>Location: California</h5>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BuildingTypeView

